export default __webpack_public_path__ + "6ddcce99d9ec12220e0f78621130bb81.svg";